<script>
  import TwoStripes from './default/TwoStripes.svelte';
  import Quote from './Quote.svelte';
  import Image from './default/Image.svelte';
  import Gallery from './default/Gallery.svelte';
  import Wysiwyg from './default/Wysiwyg.svelte';
  import Questions from './singleService/questions/Index.svelte';
  import Diagram from './singleService/diagram/Index.svelte';
  import DiagramImage from './singleService/DiagramImage.svelte';
  import TwoColumns from './default/TwoColumns.svelte';

  export let blocks;

  const blockMapping = {
    quote: Quote,
    image: Image,
    gallery: Gallery,
    wysiwyg: Wysiwyg,
    diagram: Diagram,
    questions: Questions,
    diagramImage: DiagramImage,
    twoColumns: TwoColumns,
  };
</script>

<div class="container container--large">
  <div class="inner-container inner-container--tight">
    <div class="entry-content">
      {#each blocks as block}
        <svelte:component this={blockMapping[block.type]} {...block.data} />
      {/each}
    </div>
    <div class="inner-container__two-stripes">
      <TwoStripes />
    </div>
  </div>
</div>

<style lang="scss">
  .inner-container {
    border-radius: 20px;
    padding: 8rem 13.6rem 0;
    box-shadow: 3px 3px rgba(var(--black), 0.02);
    background-color: rgb(var(--white));
    margin-top: 10rem;
    margin-bottom: 10rem;
    position: relative;

    @include resp-max('s') {
      margin-bottom: 6rem;
    }

    &--tight {
      padding: 8rem 20rem;

      @include resp-max('m') {
        padding: 5rem 2rem 6rem;
      }

      @include resp-max('s') {
        margin-top: 5rem;
        padding: 2rem;
        padding-bottom: 6rem;
      }
    }

    &__two-stripes {
      position: absolute;
      bottom: 0;
      right: 4.7rem;

      @include resp-max('m') {
        right: 50%;
        transform: translate(50%);
        max-width: 2.1rem;
      }
    }
  }
</style>
